export default function VisitationView() {
  return (
    <div className="flex justify-center items-center bg-gray-200 h-full">
      <div className="font-bold text-center text-2xl">
        Visitation Log will keep track of who visited the patients room and when
        using a QR code that the DR. will have to scan upon entry. If not that
        hard send push notifications to said person.
      </div>
    </div>
  );
}
